import { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Col, DatePicker, Row } from 'antd';

import { getShipmentListInProgress, setShipmentFilters, setShipmentList } from '@/redux/Savers/SaversActions';
import Button from '@/views/components/Buttons/Button';
import FormSelectBox from '@/views/components/Inputs/FormSelectBox';
import SecondaryLabel from '@/views/components/Labels/SecondaryLabel';
import { useGetPartnerLocations } from '@/views/screens/Savers/hooks/use-get-partner-locations';
import { useGetTrafficCoordinators } from '@/views/screens/Savers/hooks/use-get-traffic-coordinators';

import { USER_TYPES } from './constants';

const SaversTopShipmentFilter = () => {
  const { RangePicker } = DatePicker;
  const companyId = useSelector((state) => state.auth.selectedCompany.companyId, shallowEqual);
  const shipmentFilters = useSelector((state) => state.savers.shipmentFilters, shallowEqual);
  const [isDefaultView, setIsDefaultView] = useState(true);
  const dispatch = useDispatch();
  const { data: trafficCoordinatorOptions = [], isLoading: isTrafficLoading } = useGetTrafficCoordinators({
    companyId,
    userType: USER_TYPES.ct,
  });
  const { data: partnerLocationOptions = [], isLoading: isPartnerLoading } = useGetPartnerLocations({
    customerKey: companyId,
  });

  const toggleTrailerViewMode = () => {
    setIsDefaultView((prev) => !prev);
  };

  const handleShipmentFilter = (value, shipmentKey) => {
    const { eta, etd, ...currentFilters } = shipmentFilters;

    let updatedFilters;

    if (shipmentKey === 'etd') {
      const [startDate, endDate] = value;
      updatedFilters = {
        ...currentFilters,
        etdEndDate: endDate || null,
        etdStartDate: startDate || null,
        pageNumber: 1,
      };
    } else if (shipmentKey === 'eta') {
      const [startDate, endDate] = value;
      updatedFilters = {
        ...currentFilters,
        etaEndDate: endDate || null,
        etaStartDate: startDate || null,
        pageNumber: 1,
      };
    } else {
      updatedFilters = {
        ...currentFilters,
        eta,
        etd,
        [shipmentKey]: value ?? null,
        pageNumber: 1,
      };
    }

    dispatch(
      setShipmentList({
        data: [],
        isFirstTime: false,
        progressing: true,
        totalRecords: 0,
      }),
    );
    dispatch(setShipmentFilters(updatedFilters));
    dispatch(getShipmentListInProgress());
  };

  return (
    <Col flex={1}>
      <Row gutter={20} className="p-10">
        <Col sm={4} className="pt-18">
          <Button onClick={toggleTrailerViewMode}>{isDefaultView ? 'Show All Shipments' : 'Show Default View'}</Button>
        </Col>
        <Col sm={4}>
          <FormSelectBox
            label="Assigned To"
            editMode
            name="TrafficCoord"
            margin="m-0"
            loading={isTrafficLoading}
            options={trafficCoordinatorOptions}
            placeholder="Select Assigned Coordinator"
            onChange={(e) => handleShipmentFilter(e?.value, 'assignedId')}
          />
        </Col>

        <Col sm={4}>
          <FormSelectBox
            editMode
            name="orgShipLocation"
            label="Origin Location"
            margin="m-0"
            loading={isPartnerLoading}
            options={partnerLocationOptions}
            placeholder="Select Origin Location"
            onChange={(e) => handleShipmentFilter(e?.value, 'originLocationId')}
          />
        </Col>

        <Col sm={4}>
          <FormSelectBox
            editMode
            name="destinationShipLocation"
            label="Destination Location"
            margin="m-0"
            options={partnerLocationOptions}
            loading={isPartnerLoading}
            placeholder="Select Destination Location"
            onChange={(e) => handleShipmentFilter(e?.value, 'destinationLocationId')}
          />
        </Col>

        <Col sm={4}>
          <SecondaryLabel className="f-12 text-black">Filter by ETD</SecondaryLabel>
          <RangePicker
            name="etd"
            format="MM-DD-YYYY"
            onChange={(dates, dateStrings) => handleShipmentFilter(dateStrings, 'etd')}
            className="mt-2 w-100"
            placeholder={['Start Date', 'End Date']}
          />
        </Col>

        <Col sm={4}>
          <SecondaryLabel className="f-12 text-black">Filter by ETA</SecondaryLabel>
          <RangePicker
            name="eta"
            format="MM-DD-YYYY"
            onChange={(dates, dateStrings) => handleShipmentFilter(dateStrings, 'eta')}
            className="mt-2 w-100"
            placeholder={['Start Date', 'End Date']}
          />
        </Col>
      </Row>
    </Col>
  );
};

export default SaversTopShipmentFilter;
